import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({
    namespaced: true, name: 'OtherIncomeStore'
})
export default class OtherIncomeStore extends VuexModule {}